export default function () {
  const widgetName = "fnSeoBlock";
  const widgetOpts = fnSeoBlockOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    showDescription: true,
    hasImages: true,
    textOverImage: true,
    imageIsBackground: true,
    buyNowButton: false,
    lazyLoadImages: false,
    link: [""],
    moreButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $(".fNights-content .tier-2-container").remove();
      } else {
        createCustomSeo(data.items);
      }
    },
  });

  function createCustomSeo(widgetData) {
    const { Title, Description } = widgetData[0];
    const $seoItem = $(`#${widgetName}`).find(".card-widget-item");

    $seoItem.find(".card-content").replaceWith(`
      <h1 class="card-widget-title">${Title}</h1>
      <p class="card-widget-description">${Description}</p>
      `);
  }
}
